import { combineReducers } from 'redux';
import admin from './adminReducer';
import user from './user';

export default combineReducers({
    admin,
    user,
});